<script lang="ts">
	import { page } from '$app/stores';
	import Text from '$lib/components/Text.svelte';
	import Section from '$lib/components/layout/Section.svelte';
	import GlobalMedia from '$lib/components/media/GlobalMedia.svelte';
	import Button from '$lib/components/util/Button.svelte';

	const error_text_key = 'error_page__' + ($page.status ?? 'default');
</script>

<Section class="error-page" gapType="padding">
	<div slot="background" class="background">
		<GlobalMedia key="error-video" fit="cover" />
	</div>
	<div class="wrapper">
		<div class="content">
			<div class="text">
				<Text
					key={error_text_key in $page.data.globalTexts ? error_text_key : 'error_page__default'}
				/>
			</div>
			<div class="error">Error {$page.status}</div>
			<a href="/" class="button-wrapper">
				<Text key="error_page__back_to_home" /><span
					><GlobalMedia key="icon-arrow-right-long" /></span
				>
			</a>
		</div>
	</div>
</Section>

<style lang="scss">
	:global(.error-page) {
		min-height: calc(100vh - v(header__height));
		color: color(white);

		display: flex;
		justify-content: center;
		align-items: center;
	}
	.background {
		height: 100%;
	}

	.wrapper {
		color: color(black);
		display: flex;
		flex-direction: column;
		gap: v(content-gap-md);
		justify-content: center;
		align-items: center;
		height: 100%;
		width: 100%;
		.content {
			background: color(white);
			padding: v(content-gap-2xl);
			@include media(phone) {
				padding: v(content-gap);
			}
		}
		.error {
			@include font(text-sm);
			padding-top: v(content-padding);
			padding-bottom: v(content-padding-sm);
		}

		.text {
			@include font(h1);
			border-bottom: solid 1px color(black);
			padding-bottom: v(content-padding);
			max-width: 10ch;
		}

		.button-wrapper {
			text-decoration: none;
			color: color(black);
			display: flex;
			align-items: center;
			@include font(h6);
			gap: v(content-gap-sm);
			:global(svg) {
				width: 24px;
			}
			&:hover {
				text-decoration: underline;
			}
		}
	}
</style>
